import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiX } from "react-icons/si";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4 footer-copywright">
            <h3>Designed &amp; Developed by Vedant Gaidhane</h3>
          </div>
          <div className="col-md-4 footer-copywright">
            <h3>Copyright © {year} VG</h3>
          </div>
          <div className="col-md-4 footer-body">
            <ul className="footer-icons">
              <li className="social-icons">
                <a href="https://github.com/Vedantgaidhane" target="_blank" rel="noopener noreferrer">
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://x.com/VedantGaidhane?t=1pTPD2TV7g7Dsjb5xJq_rg&s=09" target="_blank" rel="noopener noreferrer">
                  <SiX />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.linkedin.com/in/vedant-gaidhane-4a4051208" target="_blank" rel="noopener noreferrer">
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.instagram.com/vedant_gaidhane?igsh=MXI5cWwxcW9qenlsMg==" target="_blank" rel="noopener noreferrer">
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
